// extracted by mini-css-extract-plugin
export default {"listButtonsWrapper":"permissions_groups_page-module___listButtonsWrapper___b18e7598"};